// English strings (source language): dashboard.

const en = {
  form: { fresh: 'Fresh', tired: 'Tired', loading: 'Building', balanced: 'Balanced' },
  hello: (name: string) => `Hello ${name}`,
  streak: (n: number) => `${n}-day streak`,
  xpToNext: (cur: string, total: string, next: number) => `${cur} / ${total} XP to level ${next}`,
  quickRace: 'Quick race',
  planWorkout: 'Plan workout',
  dailyWorkout: 'Workout of the day',
  online: 'With friends',
  quickRaceInfo: 'Quick race:',
  suggested: 'Suggested workout:',
  thisWeek: 'This week',
  distance: 'Distance',
  weekTss: 'TSS this week',
  totalRides: 'Total activities',
  fitnessTitle: 'Fitness and fatigue',
  fitness: (n: string) => `Fitness ${n}`,
  fatigue: (n: string) => `Fatigue ${n}`,
  freshness: (n: string, label: string) => `Form ${n} · ${label}`,
  legendFitness: 'fitness (42-day load)',
  legendFatigue: 'fatigue (7 days)',
  legendTss: 'daily TSS',
  weeklyHours: 'Hours per week',
  powerCurve: 'Power curve',
  days90: '90 days',
  record: 'all-time',
  plan: 'Training plan',
  manage: 'Manage',
  noPlan: 'No plan in progress.',
  choosePlan: 'Choose a plan',
  recent: 'Recent activities',
  seeAll: 'See all',
  noActivity: 'No activity yet. Start a quick race!',
  recentAch: 'Recent achievements',
  noAch: 'Your achievements will show up here.',
  planProgress: (done: number, total: number) => `${done} / ${total} workouts`,
  nextWorkout: (week: number) => `Next workout · week ${week}`,
  start: 'Start',
  upcoming: 'Upcoming starts',
  calendarLink: 'Calendar and tours',
  getStarted: {
    title: 'Get started',
    intro: 'Three steps to kick off your progress. Your stats will show up after your first ride.',
    trainer: 'Connect your smart trainer',
    trainerOk: 'Smart trainer connected',
    trainerHelp: 'Bluetooth FTMS: grade, ERG mode and power. Riding needs a trainer or a power meter.',
    connect: 'Connect',
    race: 'Do your first race',
    raceHelp: 'Against bots matched to your W/kg. A few minutes is enough to earn your first XP.',
    plan: 'Pick a programme',
    planHelp: 'Weeks of structured workouts that adapt to how you feel.',
    choose: 'See programmes',
  },
  planDone: '🎓 Plan completed!',
};
export default en;
